import React from 'react'

import  { StyledRow, CalendlyWrapper } from './CalendlyBooking.styles';

const iframeStyle = {
  backgroundColor: "#2a2a2a",
};

const CalendlyBooking = props =>  {

    return (
      <div style={{ backgroundColor: "#2a2a2a", width: "100%" }}>
        <StyledRow>
          <CalendlyWrapper height={props.height ? props.height : "70vh"} width={props.width ? props.width : "600px"} >
            <iframe
              src={props.url}
              width="100%"
              height="100%"
              frameBorder="0"
              style={iframeStyle}
            />
          </CalendlyWrapper>
        </StyledRow>
      </div>
    );
}

export default CalendlyBooking;



// WEBPACK FOOTER //
// ./src/components/CalendlyBooking/CalendlyBooking.Component.tsx